import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';

import './styles.css';

import { App } from '@/app/App';
import { ConfigError, getConfig } from '@/config/env';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html.');
}

const root = createRoot(container);

try {
  // Fail fast and loudly on a broken deployment configuration instead of
  // rendering an app that would misbehave on the first API call.
  getConfig();
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} catch (error) {
  if (!(error instanceof ConfigError)) {
    throw error;
  }
  // Deliberately un-translated: the i18n layer itself may not be usable when the
  // configuration is broken, and this message targets the operator, not the user.
  root.render(
    <div className="md-fatal" role="alert">
      <h1>Configuration error</h1>
      <p>{error.message}</p>
      <p>Check the environment variables of this deployment.</p>
    </div>,
  );
}
